<template>
    <Modal title="Create custom audience" width="push-40" section="showCreateDialog">
        <div class="card createActivation">
            <div class="card-body">
                <v-form ref="form">
                    <div class="row mt-4 mb-4">
                        <div class="form-inline col-md-2">
                            <i class="fas fa-cog" ></i> <span style="padding-left: 5px;"> General</span>
                        </div>
                        <div class="form-group col-md-4">
                            <v-text-field
                                v-model="description"
                                label="Audience Name"
                                :rules="[requiredName]"
                            ></v-text-field>
                        </div><!--form-group-->
                    </div>

                    <div class="activation-item-container-2">
                        <div class="row mt-4 mb-4">
                            <div class="form-inline col-md-2">
                                <i class="fas fa-hdd"></i> <span style="padding-left: 5px;"> Data</span>
                            </div>
                            <div class="form-group col-md-2">
                                <v-autocomplete
                                    v-model="analysis_type_0"
                                    :items="all_analysis_types"
                                    label="Data Sets"
                                    :rules="[requiredAnalysisType]"
                                ></v-autocomplete>
                            </div><!--form-group-->

                            <div class="form-group col-md-3" v-if="analysis_type_0 === 'Cohorts'">
                                <template>
                                    <v-container fluid>
                                        <v-autocomplete
                                            v-model="cohorts_0"
                                            :items="all_cohorts_0"
                                            label="Cohorts"
                                            :rules="[requiredCohorts]"
                                        >

                                            <template v-slot:prepend-item>
                                                <v-list-item>
                                                    <v-list-item-content>
                                                        <v-text-field v-model="search_cohorts_0" placeholder="Search" @input="search('cohorts', '0')"></v-text-field>
                                                    </v-list-item-content>
                                                </v-list-item>
                                            </template>
                                        </v-autocomplete>
                                    </v-container>
                                </template>
                            </div><!--form-group-->

                            <div class="form-group col-md-2" v-if="analysis_type_0 !== 'Cohorts'">
                                <template>
                                    <v-container fluid>
                                        <v-select
                                            v-model="signal_providers_0"
                                            :items="all_signal_providers_0"
                                            label="Signal Provider"
                                            multiple
                                            :rules="[requiredSignalsProviders]"
                                        >
                                            <template v-slot:selection="{ item, index }">
                                                <v-chip small v-if="index === 0">
                                                    <span>{{ item.text.substr(0, 10) }}<span v-if="item.text.length > 10">...</span></span>
                                                </v-chip>
                                                <span
                                                    v-if="index === 1"
                                                    class="grey--text text-caption"
                                                >
                                                  +{{ signal_providers_0.length - 1 }}
                                                </span>
                                            </template>

                                            <template v-slot:prepend-item>
                                                <v-list-item>
                                                    <v-list-item-content>
                                                        <v-text-field v-model="search_signal_providers_0" placeholder="Search" @input="search('signal_providers', '0')"></v-text-field>
                                                    </v-list-item-content>
                                                </v-list-item>

                                                <v-list-item
                                                    ripple
                                                    @click="toggle('signal_providers', '0')"
                                                >
                                                    <v-list-item-action>
                                                        <v-icon :color="signal_providers_0.length > 0 ? 'indigo darken-4' : ''">
                                                            {{ icon('signal_providers', '0') }}
                                                        </v-icon>
                                                    </v-list-item-action>
                                                    <v-list-item-content>
                                                        <v-list-item-title>
                                                            Select all
                                                        </v-list-item-title>
                                                    </v-list-item-content>
                                                </v-list-item>
                                            </template>
                                        </v-select>
                                    </v-container>
                                </template>
                            </div><!--form-group-->
                            <div class=" form-group col-md-2" v-if="analysis_type_0 !== 'Cohorts'">
                                <template>
                                    <v-container fluid>
                                        <v-select
                                            v-model="segments_0"
                                            :items="all_segments_0"
                                            label="Segments"
                                            multiple
                                        >
                                            <template v-slot:selection="{ item, index }">
                                                <v-chip small v-if="index === 0">
                                                    <span>{{ item.text.substr(0, 10) }}<span v-if="item.text.length > 10">...</span></span>
                                                </v-chip>
                                                <span
                                                    v-if="index === 1"
                                                    class="grey--text text-caption"
                                                >
                                                  +{{ segments_0.length - 1 }}
                                                </span>
                                            </template>

                                            <template v-slot:prepend-item>
                                                <v-list-item>
                                                    <v-list-item-content>
                                                        <v-text-field v-model="search_segments_0" placeholder="Search" @input="search('segments', '0')"></v-text-field>
                                                    </v-list-item-content>
                                                </v-list-item>

                                                <v-list-item
                                                    ripple
                                                    @click="toggle('segments', '0')"
                                                >
                                                    <v-list-item-action>
                                                        <v-icon :color="segments_0.length > 0 ? 'indigo darken-4' : ''">
                                                            {{ icon('segments', '0') }}
                                                        </v-icon>
                                                    </v-list-item-action>
                                                    <v-list-item-content>
                                                        <v-list-item-title>
                                                            Select all
                                                        </v-list-item-title>
                                                    </v-list-item-content>
                                                </v-list-item>
                                            </template>
                                        </v-select>
                                    </v-container>
                                </template>
                            </div><!--form-group-->
                            <div class=" form-group col-md-2" v-if="analysis_type_0 !== 'Cohorts'">
                                <template>
                                    <v-container fluid>
                                        <v-select
                                            v-model="categories_0"
                                            :items="all_categories_0"
                                            label="Category"
                                            multiple
                                            :rules="[requiredCategories_0]"
                                        >
                                            <template v-slot:selection="{ item, index }">
                                                <v-chip small v-if="index === 0">
                                                    <span>{{ item.text.substr(0, 10) }}<span v-if="item.text.length > 10">...</span></span>
                                                </v-chip>
                                                <span
                                                    v-if="index === 1"
                                                    class="grey--text text-caption"
                                                >
                                                  +{{ categories_0.length - 1 }}
                                                </span>
                                            </template>

                                            <template v-slot:prepend-item>
                                                <v-list-item>
                                                    <v-list-item-content>
                                                        <v-text-field v-model="search_categories_0" placeholder="Search" @input="search('categories', '0')"></v-text-field>
                                                    </v-list-item-content>
                                                </v-list-item>

                                                <v-list-item
                                                    ripple
                                                    @click="toggle('categories', '0')"
                                                >
                                                    <v-list-item-action>
                                                        <v-icon :color="categories_0.length > 0 ? 'indigo darken-4' : ''">
                                                            {{ icon('categories', '0') }}
                                                        </v-icon>
                                                    </v-list-item-action>
                                                    <v-list-item-content>
                                                        <v-list-item-title>
                                                            Select all
                                                        </v-list-item-title>
                                                    </v-list-item-content>
                                                </v-list-item>
                                            </template>
                                        </v-select>
                                    </v-container>
                                </template>
                            </div><!--form-group-->
                            <div class=" form-group col-md-2" v-if="analysis_type_0 !== 'Cohorts'">
                                <template>
                                    <v-container fluid>
                                        <v-select
                                            v-model="analysis_data_0"
                                            :items="all_analysis_data_0"
                                            :label="analysis_data_label_0"
                                            multiple
                                            :rules="[requiredAnalysisData]"
                                        >
                                            <template v-slot:selection="{ item, index }">
                                                <v-chip small v-if="index === 0">
                                                    <span>{{ item.text.substr(0, 10) }}<span v-if="item.text.length > 10">...</span></span>
                                                </v-chip>
                                                <span
                                                    v-if="index === 1"
                                                    class="grey--text text-caption"
                                                >
                                                  +{{ analysis_data_0.length - 1 }}
                                                </span>
                                            </template>

                                            <template v-slot:prepend-item>
                                                <v-list-item>
                                                    <v-list-item-content>
                                                        <v-text-field v-model="search_analysis_data_0" placeholder="Search" @input="search('analysis_data', '0')"></v-text-field>
                                                    </v-list-item-content>
                                                </v-list-item>

                                                <v-list-item
                                                    ripple
                                                    @click="toggle('analysis_data', '0')"
                                                >
                                                    <v-list-item-action>
                                                        <v-icon :color="analysis_data_0.length > 0 ? 'indigo darken-4' : ''">
                                                            {{ icon('analysis_data', '0') }}
                                                        </v-icon>
                                                    </v-list-item-action>
                                                    <v-list-item-content>
                                                        <v-list-item-title>
                                                            Select all
                                                        </v-list-item-title>
                                                    </v-list-item-content>
                                                </v-list-item>
                                            </template>
                                        </v-select>
                                    </v-container>
                                </template>
                            </div><!--form-group-->
                        </div>
                        <div class="row mt-4 mb-4" v-if="analysis_type_0 === 'POI'">
                            <div class="form-inline col-md-2">
                                <i class="fas fa-location-arrow"></i> <span style="padding-left: 5px;"> Location </span>
                            </div>
                            <div class="form-group col-md-2">
                                <template>
                                    <v-container fluid>
                                        <v-select
                                            v-model="countries_0"
                                            :items="all_countries_0"
                                            label="Country"
                                            multiple
                                            :rules="[requiredCountries]"
                                        >
                                            <template v-slot:item="{ active, item, attrs, on }">
                                                <v-list-item v-on="on" v-bind="attrs" #default="{ active }">
                                                    <v-list-item-action>
                                                        <v-checkbox :input-value="active"></v-checkbox>
                                                    </v-list-item-action>
                                                    <v-list-item-content>
                                                        <v-list-item-title>
                                                            {{ item.text }} <small>({{ item.value }})</small>
                                                        </v-list-item-title>
                                                    </v-list-item-content>
                                                </v-list-item>
                                            </template>

                                            <template v-slot:selection="{ item, index }">
                                                <v-chip small v-if="index === 0">
                                                    <span>{{ item.text.substr(0, 10) }}<span v-if="item.text.length > 10">...</span></span>
                                                </v-chip>
                                                <span
                                                    v-if="index === 1"
                                                    class="grey--text text-caption"
                                                >
                                                  +{{ countries_0.length - 1 }}
                                                </span>
                                            </template>

                                            <template v-slot:prepend-item>
                                                <v-list-item>
                                                    <v-list-item-content>
                                                        <v-text-field v-model="search_countries_0" placeholder="Search" @input="search('countries', '0')"></v-text-field>
                                                    </v-list-item-content>
                                                </v-list-item>

                                                <v-list-item
                                                    ripple
                                                    @click="toggle('countries', '0')"
                                                >
                                                    <v-list-item-action>
                                                        <v-icon :color="countries_0.length > 0 ? 'indigo darken-4' : ''">
                                                            {{ icon('countries', '0') }}
                                                        </v-icon>
                                                    </v-list-item-action>
                                                    <v-list-item-content>
                                                        <v-list-item-title>
                                                            Select all
                                                        </v-list-item-title>
                                                    </v-list-item-content>
                                                </v-list-item>
                                            </template>
                                        </v-select>
                                    </v-container>
                                </template>
                            </div><!--form-group-->
                            <div class=" form-group col-md-2">
                                <template>
                                    <v-container fluid>
                                        <v-select
                                            v-model="states_0"
                                            :items="all_states_0"
                                            label="State"
                                            multiple
                                        >
                                            <template v-slot:selection="{ item, index }">
                                                <v-chip small v-if="index === 0">
                                                    <span>{{ item.text.substr(0, 10) }}<span v-if="item.text.length > 10">...</span></span>
                                                </v-chip>
                                                <span
                                                    v-if="index === 1"
                                                    class="grey--text text-caption"
                                                >
                                                  +{{ states_0.length - 1 }}
                                                </span>
                                            </template>

                                            <template v-slot:prepend-item>
                                                <v-list-item>
                                                    <v-list-item-content>
                                                        <v-text-field v-model="search_states_0" placeholder="Search" @input="search('states', '0')"></v-text-field>
                                                    </v-list-item-content>
                                                </v-list-item>

                                                <v-list-item
                                                    ripple
                                                    @click="toggle('states', '0')"
                                                >
                                                    <v-list-item-action>
                                                        <v-icon :color="states_0.length > 0 ? 'indigo darken-4' : ''">
                                                            {{ icon('states', '0') }}
                                                        </v-icon>
                                                    </v-list-item-action>
                                                    <v-list-item-content>
                                                        <v-list-item-title>
                                                            Select all
                                                        </v-list-item-title>
                                                    </v-list-item-content>
                                                </v-list-item>
                                            </template>
                                        </v-select>
                                    </v-container>
                                </template>
                            </div><!--form-group-->
                            <div class=" form-group col-md-2">
                                <template>
                                    <v-container fluid>
                                        <v-select
                                            v-model="dmas_0"
                                            :items="all_dmas_0"
                                            label="DMA"
                                            multiple
                                        >
                                            <template v-slot:selection="{ item, index }">
                                                <v-chip small v-if="index === 0">
                                                    <span>{{ item.text.substr(0, 10) }}<span v-if="item.text.length > 10">...</span></span>
                                                </v-chip>
                                                <span
                                                    v-if="index === 1"
                                                    class="grey--text text-caption"
                                                >
                                                  +{{ dmas_0.length - 1 }}
                                                </span>
                                            </template>

                                            <template v-slot:prepend-item>
                                                <v-list-item>
                                                    <v-list-item-content>
                                                        <v-text-field v-model="search_dmas_0" placeholder="Search" @input="search('dmas', '0')"></v-text-field>
                                                    </v-list-item-content>
                                                </v-list-item>

                                                <v-list-item
                                                    ripple
                                                    @click="toggle('dmas', '0')"
                                                >
                                                    <v-list-item-action>
                                                        <v-icon :color="dmas_0.length > 0 ? 'indigo darken-4' : ''">
                                                            {{ icon('dmas', '0') }}
                                                        </v-icon>
                                                    </v-list-item-action>
                                                    <v-list-item-content>
                                                        <v-list-item-title>
                                                            Select all
                                                        </v-list-item-title>
                                                    </v-list-item-content>
                                                </v-list-item>
                                            </template>
                                        </v-select>
                                    </v-container>
                                </template>
                            </div><!--form-group-->
                            <div class=" form-group col-md-2">
                                <template>
                                    <v-container fluid>
                                        <v-select
                                            v-model="cities_0"
                                            :items="all_cities_0"
                                            label="City"
                                            multiple
                                        >
                                            <template v-slot:selection="{ item, index }">
                                                <v-chip small v-if="index === 0">
                                                    <span>{{ item.text.substr(0, 10) }}<span v-if="item.text.length > 10">...</span></span>
                                                </v-chip>
                                                <span
                                                    v-if="index === 1"
                                                    class="grey--text text-caption"
                                                >
                                                  +{{ cities_0.length - 1 }}
                                                </span>
                                            </template>

                                            <template v-slot:prepend-item>
                                                <v-list-item>
                                                    <v-list-item-content>
                                                        <v-text-field v-model="search_cities_0" placeholder="Search" @input="search('cities', '0')"></v-text-field>
                                                    </v-list-item-content>
                                                </v-list-item>

                                                <v-list-item
                                                    ripple
                                                    @click="toggle('cities', '0')"
                                                >
                                                    <v-list-item-action>
                                                        <v-icon :color="cities_0.length > 0 ? 'indigo darken-4' : ''">
                                                            {{ icon('cities', '0') }}
                                                        </v-icon>
                                                    </v-list-item-action>
                                                    <v-list-item-content>
                                                        <v-list-item-title>
                                                            Select all
                                                        </v-list-item-title>
                                                    </v-list-item-content>
                                                </v-list-item>
                                            </template>
                                        </v-select>
                                    </v-container>
                                </template>
                            </div><!--form-group-->
                            <div class="form-group col-md-2">
                                <v-textarea
                                    v-model="zip_codes_0"
                                    label="Zip Codes"
                                    rows="1"
                                    hint="One zip code in one row"
                                    auto-grow
                                    :rules="[zipCodeValidation]"
                                ></v-textarea>
                            </div><!--form-group-->

                        </div>
                    </div>
                    <div class="row mt-4 mb-4 ">
                        <div class="form-inline col-md-2">
                            <i class="fas fa-database"></i> <span style="padding-left: 5px;">Operator</span>
                        </div>
                        <div class="col-md-10 queryButtons">
                            <v-radio-group row v-model="query">
                                <v-radio
                                    label="None"
                                    value="Single"
                                    active-class="checked"
                                ></v-radio>
                                <v-radio
                                    label="AND"
                                    value="AND"
                                    active-class="checked"
                                ></v-radio>
                                <v-radio
                                    label="OR"
                                    value="OR"
                                    active-class="checked"
                                ></v-radio>
                            </v-radio-group>
                        </div>
                    </div>

                    <div class="activation-item-container-2" v-if="query !== 'Single'">
                        <div class="row mt-4 mb-4 ">
                            <div class="form-inline col-md-2">
                                <i class="fas fa-hdd"></i> <span style="padding-left: 5px;"> Data</span>
                            </div>
                            <div class="form-group col-md-2">
                                <v-autocomplete
                                    :items="all_analysis_types"
                                    v-model="analysis_type_1"
                                    label="Data Sets"
                                    :rules="[requiredAnalysisType]"
                                ></v-autocomplete>
                            </div><!--form-group-->

                            <div class="form-group col-md-3" v-if="analysis_type_1 === 'Cohorts'">
                                <template>
                                    <v-container fluid>
                                        <v-autocomplete
                                            v-model="cohorts_1"
                                            :items="all_cohorts_1"
                                            label="Cohorts"
                                            :rules="[requiredCohorts]"
                                        >

                                            <template v-slot:prepend-item>
                                                <v-list-item>
                                                    <v-list-item-content>
                                                        <v-text-field v-model="search_cohorts_1" placeholder="Search" @input="search('cohorts', '1')"></v-text-field>
                                                    </v-list-item-content>
                                                </v-list-item>
                                            </template>
                                        </v-autocomplete>
                                    </v-container>
                                </template>
                            </div><!--form-group-->

                            <div class="form-group col-md-2" v-if="analysis_type_1 !== 'Cohorts'">
                                <template>
                                    <v-container fluid>
                                        <v-select
                                            v-model="signal_providers_1"
                                            :items="all_signal_providers_1"
                                            label="Signal Provider"
                                            multiple
                                            :rules="[requiredSignalsProviders]"
                                        >
                                            <template v-slot:selection="{ item, index }">
                                                <v-chip small v-if="index === 0">
                                                    <span>{{ item.text.substr(0, 10) }}<span v-if="item.text.length > 10">...</span></span>
                                                </v-chip>
                                                <span
                                                    v-if="index === 1"
                                                    class="grey--text text-caption"
                                                >
                                                  +{{ signal_providers_1.length - 1 }}
                                                </span>
                                            </template>

                                            <template v-slot:prepend-item>
                                                <v-list-item>
                                                    <v-list-item-content>
                                                        <v-text-field v-model="search_signal_providers_1" placeholder="Search" @input="search('signal_providers', '1')"></v-text-field>
                                                    </v-list-item-content>
                                                </v-list-item>

                                                <v-list-item
                                                    ripple
                                                    @click="toggle('signal_providers', '1')"
                                                >
                                                    <v-list-item-action>
                                                        <v-icon :color="signal_providers_1.length > 0 ? 'indigo darken-4' : ''">
                                                            {{ icon('signal_providers', '1') }}
                                                        </v-icon>
                                                    </v-list-item-action>
                                                    <v-list-item-content>
                                                        <v-list-item-title>
                                                            Select all
                                                        </v-list-item-title>
                                                    </v-list-item-content>
                                                </v-list-item>
                                            </template>
                                        </v-select>
                                    </v-container>
                                </template>
                            </div><!--form-group-->
                            <div class="form-group col-md-2" v-if="analysis_type_1 !== 'Cohorts'">
                                <template>
                                    <v-container fluid>
                                        <v-select
                                            v-model="segments_1"
                                            :items="all_segments_1"
                                            label="Segments"
                                            multiple
                                        >
                                            <template v-slot:selection="{ item, index }">
                                                <v-chip small v-if="index === 0">
                                                    <span>{{ item.text.substr(0, 10) }}<span v-if="item.text.length > 10">...</span></span>
                                                </v-chip>
                                                <span
                                                    v-if="index === 1"
                                                    class="grey--text text-caption"
                                                >
                                                  +{{ segments_1.length - 1 }}
                                                </span>
                                            </template>

                                            <template v-slot:prepend-item>
                                                <v-list-item>
                                                    <v-list-item-content>
                                                        <v-text-field v-model="search_segments_1" placeholder="Search" @input="search('segments', '1')"></v-text-field>
                                                    </v-list-item-content>
                                                </v-list-item>

                                                <v-list-item
                                                    ripple
                                                    @click="toggle('segments', '1')"
                                                >
                                                    <v-list-item-action>
                                                        <v-icon :color="segments_1.length > 0 ? 'indigo darken-4' : ''">
                                                            {{ icon('segments', '1') }}
                                                        </v-icon>
                                                    </v-list-item-action>
                                                    <v-list-item-content>
                                                        <v-list-item-title>
                                                            Select all
                                                        </v-list-item-title>
                                                    </v-list-item-content>
                                                </v-list-item>
                                            </template>
                                        </v-select>
                                    </v-container>
                                </template>
                            </div>
                            <div class=" form-group col-md-2" v-if="analysis_type_1 !== 'Cohorts'">
                                <template>
                                    <v-container fluid>
                                        <v-select
                                            v-model="categories_1"
                                            :items="all_categories_1"
                                            label="Category"
                                            multiple
                                            :rules="[requiredCategories_1]"
                                        >
                                            <template v-slot:selection="{ item, index }">
                                                <v-chip small v-if="index === 0">
                                                    <span>{{ item.text.substr(0, 10) }}<span v-if="item.text.length > 10">...</span></span>
                                                </v-chip>
                                                <span
                                                    v-if="index === 1"
                                                    class="grey--text text-caption"
                                                >
                                                  +{{ categories_1.length - 1 }}
                                                </span>
                                            </template>

                                            <template v-slot:prepend-item>
                                                <v-list-item>
                                                    <v-list-item-content>
                                                        <v-text-field v-model="search_categories_1" placeholder="Search" @input="search('categories', '1')"></v-text-field>
                                                    </v-list-item-content>
                                                </v-list-item>

                                                <v-list-item
                                                    ripple
                                                    @click="toggle('categories', '1')"
                                                >
                                                    <v-list-item-action>
                                                        <v-icon :color="categories_1.length > 0 ? 'indigo darken-4' : ''">
                                                            {{ icon('categories', '1') }}
                                                        </v-icon>
                                                    </v-list-item-action>
                                                    <v-list-item-content>
                                                        <v-list-item-title>
                                                            Select all
                                                        </v-list-item-title>
                                                    </v-list-item-content>
                                                </v-list-item>
                                            </template>
                                        </v-select>
                                    </v-container>
                                </template>
                            </div><!--form-group-->
                            <div class=" form-group col-md-2" v-if="analysis_type_1 !== 'Cohorts'">
                                <template>
                                    <v-container fluid>
                                        <v-select
                                            v-model="analysis_data_1"
                                            :items="all_analysis_data_1"
                                            :label="analysis_data_label_1"
                                            multiple
                                            :rules="[requiredAnalysisData]"
                                        >
                                            <template v-slot:selection="{ item, index }">
                                                <v-chip small v-if="index === 0">
                                                    <span>{{ item.text.substr(0, 10) }}<span v-if="item.text.length > 10">...</span></span>
                                                </v-chip>
                                                <span
                                                    v-if="index === 1"
                                                    class="grey--text text-caption"
                                                >
                                                  +{{ analysis_data_1.length - 1 }}
                                                </span>
                                            </template>

                                            <template v-slot:prepend-item>
                                                <v-list-item>
                                                    <v-list-item-content>
                                                        <v-text-field v-model="search_analysis_data_1" placeholder="Search" @input="search('analysis_data', '1')"></v-text-field>
                                                    </v-list-item-content>
                                                </v-list-item>

                                                <v-list-item
                                                    ripple
                                                    @click="toggle('analysis_data', '1')"
                                                >
                                                    <v-list-item-action>
                                                        <v-icon :color="analysis_data_1.length > 0 ? 'indigo darken-4' : ''">
                                                            {{ icon('analysis_data', '1') }}
                                                        </v-icon>
                                                    </v-list-item-action>
                                                    <v-list-item-content>
                                                        <v-list-item-title>
                                                            Select all
                                                        </v-list-item-title>
                                                    </v-list-item-content>
                                                </v-list-item>
                                            </template>
                                        </v-select>
                                    </v-container>
                                </template>
                            </div><!--form-group-->
                        </div><!--row-->
                        <div class="row mt-4 mb-4" v-if="analysis_type_1 === 'POI'">
                            <div class="form-inline col-md-2">
                                <i class="fas fa-location-arrow"></i> <span style="padding-left: 5px;"> Location </span>
                            </div>
                            <div class=" form-group col-md-2">
                                <template>
                                    <v-container fluid>
                                        <v-select
                                            v-model="countries_1"
                                            :items="all_countries_1"
                                            label="Country"
                                            multiple
                                            :rules="[requiredCountries]"
                                        >
                                            <template v-slot:item="{ active, item, attrs, on }">
                                                <v-list-item v-on="on" v-bind="attrs" #default="{ active }">
                                                    <v-list-item-action>
                                                        <v-checkbox :input-value="active"></v-checkbox>
                                                    </v-list-item-action>
                                                    <v-list-item-content>
                                                        <v-list-item-title>
                                                            {{ item.text }} <small>({{ item.value }})</small>
                                                        </v-list-item-title>
                                                    </v-list-item-content>
                                                </v-list-item>
                                            </template>

                                            <template v-slot:selection="{ item, index }">
                                                <v-chip small v-if="index === 0">
                                                    <span>{{ item.text.substr(0, 10) }}<span v-if="item.text.length > 10">...</span></span>
                                                </v-chip>
                                                <span
                                                    v-if="index === 1"
                                                    class="grey--text text-caption"
                                                >
                                                  +{{ countries_1.length - 1 }}
                                                </span>
                                            </template>

                                            <template v-slot:prepend-item>
                                                <v-list-item>
                                                    <v-list-item-content>
                                                        <v-text-field v-model="search_countries_1" placeholder="Search" @input="search('countries', '1')"></v-text-field>
                                                    </v-list-item-content>
                                                </v-list-item>

                                                <v-list-item
                                                    ripple
                                                    @click="toggle('countries', '1')"
                                                >
                                                    <v-list-item-action>
                                                        <v-icon :color="countries_1.length > 0 ? 'indigo darken-4' : ''">
                                                            {{ icon('countries', '1') }}
                                                        </v-icon>
                                                    </v-list-item-action>
                                                    <v-list-item-content>
                                                        <v-list-item-title>
                                                            Select all
                                                        </v-list-item-title>
                                                    </v-list-item-content>
                                                </v-list-item>
                                            </template>
                                        </v-select>
                                    </v-container>
                                </template>
                            </div><!--form-group-->
                            <div class=" form-group col-md-2">
                                <template>
                                    <v-container fluid>
                                        <v-select
                                            v-model="states_1"
                                            :items="all_states_1"
                                            label="State"
                                            multiple
                                        >
                                            <template v-slot:selection="{ item, index }">
                                                <v-chip small v-if="index === 0">
                                                    <span>{{ item.text.substr(0, 10) }}<span v-if="item.text.length > 10">...</span></span>
                                                </v-chip>
                                                <span
                                                    v-if="index === 1"
                                                    class="grey--text text-caption"
                                                >
                                                  +{{ states_1.length - 1 }}
                                                </span>
                                            </template>

                                            <template v-slot:prepend-item>
                                                <v-list-item>
                                                    <v-list-item-content>
                                                        <v-text-field v-model="search_states_1" placeholder="Search" @input="search('states', '1')"></v-text-field>
                                                    </v-list-item-content>
                                                </v-list-item>

                                                <v-list-item
                                                    ripple
                                                    @click="toggle('states', '1')"
                                                >
                                                    <v-list-item-action>
                                                        <v-icon :color="states_1.length > 0 ? 'indigo darken-4' : ''">
                                                            {{ icon('states', '1') }}
                                                        </v-icon>
                                                    </v-list-item-action>
                                                    <v-list-item-content>
                                                        <v-list-item-title>
                                                            Select all
                                                        </v-list-item-title>
                                                    </v-list-item-content>
                                                </v-list-item>
                                            </template>
                                        </v-select>
                                    </v-container>
                                </template>
                            </div><!--form-group-->
                            <div class=" form-group col-md-2">
                                <template>
                                    <v-container fluid>
                                        <v-select
                                            v-model="dmas_1"
                                            :items="all_dmas_1"
                                            label="DMA"
                                            multiple
                                        >
                                            <template v-slot:selection="{ item, index }">
                                                <v-chip small v-if="index === 0">
                                                    <span>{{ item.text.substr(0, 10) }}<span v-if="item.text.length > 10">...</span></span>
                                                </v-chip>
                                                <span
                                                    v-if="index === 1"
                                                    class="grey--text text-caption"
                                                >
                                                  +{{ dmas_1.length - 1 }}
                                                </span>
                                            </template>

                                            <template v-slot:prepend-item>
                                                <v-list-item>
                                                    <v-list-item-content>
                                                        <v-text-field v-model="search_dmas_1" placeholder="Search" @input="search('dmas', '1')"></v-text-field>
                                                    </v-list-item-content>
                                                </v-list-item>

                                                <v-list-item
                                                    ripple
                                                    @click="toggle('dmas', '1')"
                                                >
                                                    <v-list-item-action>
                                                        <v-icon :color="dmas_1.length > 0 ? 'indigo darken-4' : ''">
                                                            {{ icon('dmas', '1') }}
                                                        </v-icon>
                                                    </v-list-item-action>
                                                    <v-list-item-content>
                                                        <v-list-item-title>
                                                            Select all
                                                        </v-list-item-title>
                                                    </v-list-item-content>
                                                </v-list-item>
                                            </template>
                                        </v-select>
                                    </v-container>
                                </template>
                            </div><!--form-group-->
                            <div class="form-group col-md-2">
                                <template>
                                    <v-container fluid>
                                        <v-select
                                            v-model="cities_1"
                                            :items="all_cities_1"
                                            label="City"
                                            multiple
                                        >
                                            <template v-slot:selection="{ item, index }">
                                                <v-chip small v-if="index === 0">
                                                    <span>{{ item.text.substr(0, 10) }}<span v-if="item.text.length > 10">...</span></span>
                                                </v-chip>
                                                <span
                                                    v-if="index === 1"
                                                    class="grey--text text-caption"
                                                >
                                                  +{{ cities_1.length - 1 }}
                                                </span>
                                            </template>

                                            <template v-slot:prepend-item>
                                                <v-list-item>
                                                    <v-list-item-content>
                                                        <v-text-field v-model="search_cities_1" placeholder="Search" @input="search('cities', '1')"></v-text-field>
                                                    </v-list-item-content>
                                                </v-list-item>

                                                <v-list-item
                                                    ripple
                                                    @click="toggle('cities', '1')"
                                                >
                                                    <v-list-item-action>
                                                        <v-icon :color="cities_1.length > 0 ? 'indigo darken-4' : ''">
                                                            {{ icon('cities', '1') }}
                                                        </v-icon>
                                                    </v-list-item-action>
                                                    <v-list-item-content>
                                                        <v-list-item-title>
                                                            Select all
                                                        </v-list-item-title>
                                                    </v-list-item-content>
                                                </v-list-item>
                                            </template>
                                        </v-select>
                                    </v-container>
                                </template>
                            </div><!--form-group-->
                            <div class="form-group col-md-2">
                                <v-textarea
                                    v-model="zip_codes_1"
                                    label="Zip Codes"
                                    rows="1"
                                    hint="One zip code in one row"
                                    auto-grow
                                    :rules="[zipCodeValidation]"
                                ></v-textarea>
                            </div><!--form-group-->
                        </div>
                    </div>

                    <div class="row mt-4 mb-4">
                        <div class="form-inline col-md-2">
                            <i class="far fa-calendar-alt"></i> <span style="padding-left: 5px;"> Recency</span>
                        </div>
                        <div class="form-group col-md-6">
                            <div class="input-daterange form-inline datesSelection" id="datepicker">
                                <v-menu
                                    v-model="startDateMenu"
                                    :close-on-content-click="false"
                                    :nudge-right="40"
                                    transition="scale-transition"
                                    offset-y
                                    min-width="auto"
                                >
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-text-field
                                            v-model="startDate"
                                            label="Start Date"
                                            clearable
                                            readonly
                                            v-bind="attrs"
                                            v-on="on"
                                            :rules="[requiredStartDate]"
                                        ></v-text-field>
                                    </template>
                                    <v-date-picker
                                        header-color="#fb7e42"
                                        color="#fb7e42"
                                        v-model="startDate"
                                        @input="startDateMenu = false"
                                        :max="endDate"
                                    ></v-date-picker>
                                </v-menu>
                                <span class="mx-2">to</span>
                                <v-menu
                                    v-model="endDateMenu"
                                    :close-on-content-click="false"
                                    :nudge-right="40"
                                    transition="scale-transition"
                                    offset-y
                                    min-width="auto"
                                >
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-text-field
                                            v-model="endDate"
                                            label="End Date"
                                            clearable
                                            readonly
                                            v-bind="attrs"
                                            v-on="on"
                                            :rules="[requiredEndDate]"
                                        ></v-text-field>
                                    </template>
                                    <v-date-picker
                                        header-color="#fb7e42"
                                        color="#fb7e42"
                                        v-model="endDate"
                                        @input="endDateMenu = false"
                                        :min="startDate"
                                    ></v-date-picker>
                                </v-menu>
                            </div>
                            <div class="recency-options">
                                <span class="mr-2" @click="setRecency('7', 'days')">Last 7 days</span>
                                <span class="mr-2" @click="setRecency('30', 'days')">Last 30 days</span>
                                <span class="mr-2" @click="setRecency('90', 'days')">Last 90 days</span>
                                <span class="mr-2" @click="setRecency('this-month', 'period')">This Month</span>
                                <span class="mr-2" @click="setRecency('last-month', 'period')">Last Full Month</span>
                            </div>
                        </div><!--form-group-->
                    </div>

                    <div class="row mt-4 mb-4">
                        <div class="form-inline col-md-2">
                            <i class="fas fa-map-signs"></i> <span style="padding-left: 5px;">Anomaly Detection </span>
                        </div>

                        <div class="form-group col-md-2">
                            <v-autocomplete
                                    v-model="abnormality"
                                    :items="abnormality_types"
                                    label="Review"
                            ></v-autocomplete>
                        </div><!--form-group-->
                    </div>

                    <div class="row mt-4 mb-4">
                        <div class="form-inline col-md-2">
                            <i class="fas fa-chart-area"></i> <span style="padding-left: 5px;">Analyses </span>
                        </div>

                        <div class="col-md-10">
                            <div class="row">
                                <div class="col-md-3 push-down-36">
                                    <v-switch
                                        v-model="audience"
                                        inset
                                        disabled
                                        label="Audience"
                                    ></v-switch>
                                </div><!--form-group-->
                                <div class="col-md-3" :class="[permissions.includes('feature-activation-analyses-crossvisitation') ? 'push-down-36' : '']">

                                    <v-tooltip
                                        v-if="!permissions.includes('feature-activation-analyses-crossvisitation')"
                                        top
                                    >
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-btn
                                                icon
                                                v-bind="attrs"
                                                v-on="on"
                                            >
                                                <v-icon color="blue lighten-1">
                                                    mdi-information-outline
                                                </v-icon>
                                            </v-btn>
                                        </template>
                                        <span>Contact your account manager <br> to use this functionality.</span>
                                    </v-tooltip>


                                    <v-switch
                                        v-model="crossVisitation"
                                        inset
                                        :disabled="!permissions.includes('feature-activation-analyses-crossvisitation')"
                                        label="CrossVisitation"
                                    ></v-switch>
                                </div><!--form-group-->
                                <div class="col-md-3" :class="[permissions.includes('feature-activation-analyses-crossapps') ? 'push-down-36' : '']">

                                    <v-tooltip
                                        v-if="!permissions.includes('feature-activation-analyses-crossapps')"
                                        top
                                    >
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-btn
                                                icon
                                                v-bind="attrs"
                                                v-on="on"
                                            >
                                                <v-icon color="blue lighten-1">
                                                    mdi-information-outline
                                                </v-icon>
                                            </v-btn>
                                        </template>
                                        <span>Contact your account manager <br> to use this functionality.</span>
                                    </v-tooltip>

                                    <v-switch
                                        v-model="crossApps"
                                        inset
                                        :disabled="!permissions.includes('feature-activation-analyses-crossapps')"
                                        label="CrossApps"
                                    ></v-switch>
                                </div><!--form-group-->
                                <div class="col-md-3" :class="[permissions.includes('feature-activation-analyses-frequency') ? 'push-down-36' : '']">

                                    <v-tooltip
                                        v-if="!permissions.includes('feature-activation-analyses-frequency')"
                                        top
                                    >
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-btn
                                                icon
                                                v-bind="attrs"
                                                v-on="on"
                                            >
                                                <v-icon color="blue lighten-1">
                                                    mdi-information-outline
                                                </v-icon>
                                            </v-btn>
                                        </template>
                                        <span>Contact your account manager <br> to use this functionality.</span>
                                    </v-tooltip>

                                    <v-switch
                                        v-model="frequency"
                                        inset
                                        :disabled="!permissions.includes('feature-activation-analyses-frequency')"
                                        label="Frequency"
                                    ></v-switch>
                                </div><!--form-group-->
                            </div>
                        </div>
                    </div>

                    <div class="row mt-4" v-if="crossVisitation">
                        <div class="form-inline col-md-2">
                            <i class="fas fa-hdd"></i> <span style="padding-left: 5px;">Cross Data </span>
                        </div>
                        <div class=" form-group col-md-3">
                            <template>
                                <v-container fluid>
                                    <v-select
                                        v-model="categories_cross"
                                        :items="all_categories_cross"
                                        label="Category"
                                        multiple
                                        :rules="[requiredValidCategories, maximumCategories]"
                                    >
                                        <template v-slot:selection="{ item, index }">
                                            <v-chip small v-if="index === 0">
                                                <span>{{ item.text.substr(0, 10) }}<span v-if="item.text.length > 10">...</span></span>
                                            </v-chip>
                                            <span
                                                v-if="index === 1"
                                                class="grey--text text-caption"
                                            >
                                                  +{{ categories_cross.length - 1 }}
                                                </span>
                                        </template>

                                        <template v-slot:prepend-item>
                                            <v-list-item>
                                                <v-list-item-content>
                                                    <v-text-field v-model="search_categories_cross" placeholder="Search" @input="search('categories', 'cross')"></v-text-field>
                                                </v-list-item-content>
                                            </v-list-item>

                                            <v-list-item
                                                ripple
                                                @click="toggle('categories', 'cross')"
                                            >
                                                <v-list-item-action>
                                                    <v-icon :color="categories_cross.length > 0 ? 'indigo darken-4' : ''">
                                                        {{ icon('categories', 'cross') }}
                                                    </v-icon>
                                                </v-list-item-action>
                                                <v-list-item-content>
                                                    <v-list-item-title>
                                                        Select all
                                                    </v-list-item-title>
                                                </v-list-item-content>
                                            </v-list-item>
                                        </template>
                                    </v-select>
                                </v-container>
                            </template>
                            <small><strong>{{ categories_cross.length }}</strong> categories from <strong>5</strong> allowed were selected.</small>
                        </div><!--form-group-->
                        <div class=" form-group col-md-3">
                            <template>
                                <v-container fluid>
                                    <v-select
                                        v-model="analysis_data_cross"
                                        :items="all_analysis_data_cross"
                                        label="Brands"
                                        multiple
                                    >
                                        <template v-slot:selection="{ item, index }">
                                            <v-chip small v-if="index === 0">
                                                <span>{{ item.text.substr(0, 10) }}<span v-if="item.text.length > 10">...</span></span>
                                            </v-chip>
                                            <span
                                                v-if="index === 1"
                                                class="grey--text text-caption"
                                            >
                                                  +{{ analysis_data_cross.length - 1 }}
                                                </span>
                                        </template>

                                        <template v-slot:prepend-item>
                                            <v-list-item>
                                                <v-list-item-content>
                                                    <v-text-field v-model="search_analysis_data_cross" placeholder="Search" @input="search('analysis_data', 'cross')"></v-text-field>
                                                </v-list-item-content>
                                            </v-list-item>

                                            <v-list-item
                                                ripple
                                                @click="toggle('analysis_data', 'cross')"
                                            >
                                                <v-list-item-action>
                                                    <v-icon :color="analysis_data_cross.length > 0 ? 'indigo darken-4' : ''">
                                                        {{ icon('analysis_data', 'cross') }}
                                                    </v-icon>
                                                </v-list-item-action>
                                                <v-list-item-content>
                                                    <v-list-item-title>
                                                        Select all
                                                    </v-list-item-title>
                                                </v-list-item-content>
                                            </v-list-item>
                                        </template>
                                    </v-select>
                                </v-container>
                            </template>
                        </div><!--form-group-->
                    </div>

                    <div class="row mt-4" v-if="crossVisitation">
                        <div class="form-inline col-md-2">
                            <i class="fas fa-location-arrow"></i> <span style="padding-left: 5px;">Cross Visitation </span>
                        </div>
                        <div class="form-group col-md-4 push-down-36">
                            <v-switch
                                v-model="poi_location_level"
                                inset
                                label="POI Location level"
                            ></v-switch>
                        </div><!--form-group-->
                    </div>

                    <div class="row mt-4 mb-4" v-if="frequency">
                        <div class="form-inline col-md-2">
                            <i class="fas fa-wave-square"></i> <span style="padding-left: 5px;">Frequency </span>
                        </div>
                        <div class="form-group col-md-4">
                            <v-text-field
                                v-model="minfreq"
                                label="Min. Freq"
                                type="number"
                                :rules="[requiredMinfreq]"
                            ></v-text-field>
                        </div><!--form-group-->
                        <div class="form-group col-md-4">
                            <v-text-field
                                v-model="maxfreq"
                                label="Max. Freq"
                                type="number"
                            ></v-text-field>
                        </div><!--form-group-->
                    </div>

                    <hr>

                    <div class="row">
                        <div class="col-1 text-left">
                            <button @click="close()" class="btn btn-danger">
                                Cancel
                            </button>
                        </div>
                        <div class="col-2 offset-9 text-right">
                            <button @click="submitData()" class="btn btn-success">
                                Create
                            </button>
                        </div>
                    </div>
                </v-form>
            </div>
        </div><!--card-->
    </Modal>
</template>

<script>
import Modal from '../Modal'
import api from "../../api/analyses/activations";
import poiApi from "../../api/analyses/poi-locations";
export default {
    name: "CreateNewPrivateAudience",
    components: {
        Modal
    },
    props: [
        'dataObject'
    ],
    data: () => ({
        description: '',
        all_analysis_types: [],

        analysis_type_0: '',

        all_signal_providers_0: [],
        all_signal_providers_0_copy: [],
        signal_providers_0: [],
        search_signal_providers_0: '',
        signal_providers_0_loading: false,

        all_segments_0: [],
        all_segments_0_copy: [],
        segments_0: [],
        search_segments_0: '',
        segments_0_loading: false,

        all_categories_0: [],
        all_categories_0_copy: [],
        categories_0: [],
        search_categories_0: '',
        categories_0_loading: false,

        all_analysis_data_0: [],
        all_analysis_data_0_copy: [],
        analysis_data_0: [],
        search_analysis_data_0: '',
        analysis_data_label_0: 'Analysis Data',
        analysis_data_0_loading: false,

        all_countries_0: [],
        all_countries_0_copy: [],
        countries_0: [],
        search_countries_0: '',
        countries_0_loading: false,

        all_states_0: [],
        all_states_0_copy: [],
        states_0: [],
        search_states_0: '',
        states_0_loading: false,

        all_dmas_0: [],
        all_dmas_0_copy: [],
        dmas_0: [],
        search_dmas_0: '',
        dmas_0_loading: false,

        all_cohorts_0: [],
        all_cohorts_0_copy: [],
        cohorts_0: '',
        search_cohorts_0: '',
        cohorts_0_loading: false,

        all_cities_0: [],
        all_cities_0_copy: [],
        cities_0: [],
        search_cities_0: '',
        cities_0_loading: false,

        zip_codes_0: '',

        query: 'Single',

        analysis_type_1: '',

        all_signal_providers_1: [],
        all_signal_providers_1_copy: [],
        signal_providers_1: [],
        search_signal_providers_1: '',
        signal_providers_1_loading: false,

        all_segments_1: [],
        all_segments_1_copy: [],
        segments_1: [],
        search_segments_1: '',
        segments_1_loading: false,

        all_categories_1: [],
        all_categories_1_copy: [],
        categories_1: [],
        search_categories_1: '',
        categories_1_loading: false,

        all_analysis_data_1: [],
        all_analysis_data_1_copy: [],
        analysis_data_1: [],
        search_analysis_data_1: '',
        analysis_data_label_1: 'Analysis Data',
        analysis_data_1_loading: false,

        all_countries_1: [],
        all_countries_1_copy: [],
        countries_1: [],
        search_countries_1: '',
        countries_1_loading: false,

        all_states_1: [],
        all_states_1_copy: [],
        states_1: [],
        search_states_1: '',
        states_1_loading: false,

        all_dmas_1: [],
        all_dmas_1_copy: [],
        dmas_1: [],
        search_dmas_1: '',
        dmas_1_loading: false,

        all_cohorts_1: [],
        all_cohorts_1_copy: [],
        cohorts_1: '',
        search_cohorts_1: '',
        cohorts_1_loading: false,

        all_cities_1: [],
        all_cities_1_copy: [],
        cities_1: [],
        search_cities_1: '',
        cities_1_loading: false,

        zip_codes_1: '',

        startDateMenu: false,
        startDate: '',
        convStartDate: '',

        endDateMenu: false,
        endDate: '',
        convEndDate: '',

        minfreq: 1,
        maxfreq: null,

        audience: true,
        crossVisitation: false,
        crossApps: false,
        frequency: false,

        poi_location_level: false,

        analysis_type_cross: 'POI',

        all_categories_cross: [],
        all_categories_cross_copy: [],
        categories_cross: [],
        search_categories_cross: '',

        all_analysis_data_cross: [],
        all_analysis_data_cross_copy: [],
        analysis_data_cross: [],
        search_analysis_data_cross: '',

        abnormality: 1,

        dataInitialLoading: true,

        requiredName: v => v && v.length > 0 || 'Audience Name field is required',
        requiredAnalysisType: v => v && v.length > 0 || 'Data Sets field is required',
        requiredSignalsProviders: v => v && v.length > 0 || 'Signal Provider field is required',
        requiredAnalysisData: v => v && v.length > 0 || 'Analysis Data field is required',
        requiredCohorts: v => v && v > 0 || 'Cohorts field is required',
        requiredCountries: v => v && v.length > 0 || 'Country field is required',
        requiredStartDate: v => v && v.length > 0 || 'Start Date field is required',
        requiredEndDate: v => v && v.length > 0 || 'End Date field is required',
        requiredMinfreq: v => v && v > 0 || 'Minimum Frequency has to be minimum 1',
        maximumCategories: v => v && v.length < 6 || 'Only 5 categories can be selected.',
    }),
    methods: {
        async fetchAnalysisTypes() {
            await api.getAnalysisTypes()
                .then(res => {
                    this.all_analysis_types = res.data
                })
        },
        async fetchSignalProviders() {
            await api.getSignalProviders()
                .then(res => {
                    this.all_signal_providers_0 = res.data
                    this.all_signal_providers_0_copy = res.data
                    this.all_signal_providers_1 = res.data
                    this.all_signal_providers_1_copy = res.data
                })
        },
        async fetchSegments() {
            await api.getSegments()
                .then(res => {
                    this.all_segments_0 = res.data
                    this.all_segments_0_copy = res.data
                    this.all_segments_1 = res.data
                    this.all_segments_1_copy = res.data
                })
        },
        async fetchCategories() {
            await api.getCategories()
                .then(res => {
                    this.all_categories_cross = res.data
                    this.all_categories_cross_copy = res.data
                })
        },
        async fetchCountries() {
            await api.getCountries()
                .then(res => {
                    this.all_countries_0 = res.data
                    this.all_countries_0_copy = res.data
                    this.all_countries_1 = res.data
                    this.all_countries_1_copy = res.data
                })
        },
        async fetchDmas() {
            await api.getDmas()
                .then(res => {
                    this.all_dmas_0 = res.data
                    this.all_dmas_0_copy = res.data
                    this.all_dmas_1 = res.data
                    this.all_dmas_1_copy = res.data
                })
        },
        async fetchCohorts() {
            await api.getCohorts()
                .then(res => {
                    this.all_cohorts_0 = res.data
                    this.all_cohorts_0_copy = res.data
                    this.all_cohorts_1 = res.data
                    this.all_cohorts_1_copy = res.data
                })
        },
        async fetchAnalysisDataByCategory(order) {
            await api.getAnalysisDataByCategory({
                analysisType: this.$data['analysis_type_' + order],
                categories: this.$data['categories_' + order],
                _token: $('meta[name="_token"]').attr('content')
            })
            .then(res => {
                this.$data['all_analysis_data_' + order] = res.data
                this.$data['all_analysis_data_' + order + '_copy'] = res.data
            })
        },
        async fetchCategoriesBySegment(order) {
            await api.getCategoriesBySegments({
                segments: this.$data['segments_' + order],
                _token: $('meta[name="_token"]').attr('content')
            })
            .then(res => {
                this.$data['all_categories_' + order] = res.data
                this.$data['all_categories_' + order + '_copy'] = res.data

                if (this.$data['segments_' + order].length < 1) {
                    this.fetchCategories()
                }
            })
        },
        async fetchStatesByCountries(order) {
            await api.getStatesByCountries({
                countries: this.$data['countries_' + order],
                _token: $('meta[name="_token"]').attr('content')
            })
            .then(res => {
                this.$data['all_states_' + order] = res.data
                this.$data['all_states_' + order + '_copy'] = res.data
            })
        },
        async fetchCitiesByStates(order) {
            await api.getCitiesByStates({
                states: this.$data['states_' + order],
            })
            .then(res => {
                this.$data['all_cities_' + order] = res.data
                this.$data['all_cities_' + order + '_copy'] = res.data
            })
        },
        async fetchCountriesByData(order) {
            await api.getCountriesBySelectedData({
                analysisData: this.$data['analysis_data_' + order],
                _token: $('meta[name="_token"]').attr('content')
            })
            .then(res => {
                this.$data['all_countries_' + order] = res.data
                this.$data['all_countries_' + order + '_copy'] = res.data
            })
        },
        async fetchDataByCountries(order) {
            await api.getDataBySelectedCountries({
                countries: this.$data['countries_' + order],
                analysisType: this.$data['analysis_type_' + order],
                categories: this.$data['categories_' + order],
            })
            .then(res => {
                this.$data['all_analysis_data_' + order] = res.data
                this.$data['all_analysis_data_' + order + '_copy'] = res.data
            })
        },
        async fetchInitialData() {
            await poiApi.getInitialData()
                .then(res => {
                    this.all_signal_providers_0 = res.data.providers
                    this.all_signal_providers_0_copy = res.data.providers
                    this.all_signal_providers_1 = res.data.providers
                    this.all_signal_providers_1_copy = res.data.providers

                    this.all_segments_0 = res.data.segments
                    this.all_segments_0_copy = res.data.segments
                    this.all_segments_1 = res.data.segments
                    this.all_segments_1_copy = res.data.segments

                    this.all_categories_0 = res.data.categories
                    this.all_categories_0_copy = res.data.categories
                    this.all_categories_1 = res.data.categories
                    this.all_categories_1_copy = res.data.categories

                    this.all_analysis_data_0 = res.data.analysis_data
                    this.all_analysis_data_0_copy = res.data.analysis_data
                    this.all_analysis_data_1 = res.data.analysis_data
                    this.all_analysis_data_1_copy = res.data.analysis_data

                    this.all_cities_0 = res.data.cities
                    this.all_cities_0_copy = res.data.cities
                    this.all_cities_1 = res.data.cities
                    this.all_cities_1_copy = res.data.cities

                    this.all_dmas_0 = res.data.dmas
                    this.all_dmas_0_copy = res.data.dmas
                    this.all_dmas_1 = res.data.dmas
                    this.all_dmas_1_copy = res.data.dmas

                    this.all_countries_0 = res.data.countries
                    this.all_countries_0_copy = res.data.countries
                    this.all_countries_1 = res.data.countries
                    this.all_countries_1_copy = res.data.countries

                    this.all_states_0 = res.data.states
                    this.all_states_0_copy = res.data.states
                    this.all_states_1 = res.data.states
                    this.all_states_1_copy = res.data.states

                    if (this.dataObject !== undefined) {
                        this.usePropsData()
                    }

                    this.dataInitialLoading = false
                })
        },
        async fetchChangedData(field, order) {
            this.dataReloading(field, order)
            await poiApi.getDataByChangedField({
                field: field,
                segments: this.$data['segments_' + order],
                categories: this.$data['categories_' + order],
                pois: this.$data['analysis_data_' + order],
                countries: this.$data['countries_' + order],
                states: this.$data['states_' + order],
                dmas: this.$data['dmas' + order],
                cities: this.$data['cities_' + order],
                zipcodes: this.$data['zip_codes_' + order]
            })
                .then(res => {
                    if (field === 'segments') {
                        this.$data['all_categories_' + order] = res.data.categories
                        this.$data['all_categories_' + order + '_copy'] = res.data.categories
                        this.$data['categories_' + order + '_loading'] = false

                        this.$data['all_analysis_data_' + order] = res.data.analysis_data
                        this.$data['all_analysis_data_' + order + '_copy'] = res.data.analysis_data
                        this.$data['analysis_data_' + order + '_loading'] = false

                        this.$data['all_countries_' + order] = res.data.countries
                        this.$data['all_countries_' + order + '_copy'] = res.data.countries
                        this.$data['countries_' + order + '_loading'] = false

                        this.$data['all_states_' + order] = res.data.states
                        this.$data['all_states_' + order + '_copy'] = res.data.states
                        this.$data['states_' + order + '_loading'] = false

                        this.$data['all_dmas_' + order] = res.data.dmas
                        this.$data['all_dmas_' + order + '_copy'] = res.data.dmas
                        this.$data['dmas_' + order + '_loading'] = false

                        this.$data['all_cities_' + order] = res.data.cities
                        this.$data['all_cities_' + order + '_copy'] = res.data.cities
                        this.$data['cities_' + order + '_loading'] = false
                    }

                    if (field === 'categories') {
                        this.$data['all_analysis_data_' + order] = res.data.analysis_data
                        this.$data['all_analysis_data_' + order + '_copy'] = res.data.analysis_data
                        this.$data['analysis_data_' + order + '_loading'] = false

                        this.$data['all_countries_' + order] = res.data.countries
                        this.$data['all_countries_' + order + '_copy'] = res.data.countries
                        this.$data['countries_' + order + '_loading'] = false

                        this.$data['all_states_' + order] = res.data.states
                        this.$data['all_states_' + order + '_copy'] = res.data.states
                        this.$data['states_' + order + '_loading'] = false

                        this.$data['all_dmas_' + order] = res.data.dmas
                        this.$data['all_dmas_' + order + '_copy'] = res.data.dmas
                        this.$data['dmas_' + order + '_loading'] = false

                        this.$data['all_cities_' + order] = res.data.cities
                        this.$data['all_cities_' + order + '_copy'] = res.data.cities
                        this.$data['cities_' + order + '_loading'] = false
                    }

                    if (field === 'analysis_data') {
                        this.$data['all_countries_' + order] = res.data.countries
                        this.$data['all_countries_' + order + '_copy'] = res.data.countries
                        this.$data['countries_' + order + '_loading'] = false

                        this.$data['all_states_' + order] = res.data.states
                        this.$data['all_states_' + order + '_copy'] = res.data.states
                        this.$data['states_' + order + '_loading'] = false

                        this.$data['all_dmas_' + order] = res.data.dmas
                        this.$data['all_dmas_' + order + '_copy'] = res.data.dmas
                        this.$data['dmas_' + order + '_loading'] = false

                        this.$data['all_cities_' + order] = res.data.cities
                        this.$data['all_cities_' + order + '_copy'] = res.data.cities
                        this.$data['cities_' + order + '_loading'] = false
                    }

                    if (field === 'countries') {
                        this.$data['all_states_' + order] = res.data.states
                        this.$data['all_states_' + order + '_copy'] = res.data.states
                        this.$data['states_' + order + '_loading'] = false

                        this.$data['all_dmas_' + order] = res.data.dmas
                        this.$data['all_dmas_' + order + '_copy'] = res.data.dmas
                        this.$data['dmas_' + order + '_loading'] = false

                        this.$data['all_cities_' + order] = res.data.cities
                        this.$data['all_cities_' + order + '_copy'] = res.data.cities
                        this.$data['cities_' + order + '_loading'] = false
                    }

                    if (field === 'states') {
                        this.$data['all_dmas_' + order] = res.data.dmas
                        this.$data['all_dmas_' + order + '_copy'] = res.data.dmas
                        this.$data['dmas_' + order + '_loading'] = false

                        this.$data['all_cities_' + order] = res.data.cities
                        this.$data['all_cities_' + order + '_copy'] = res.data.cities
                        this.$data['cities_' + order + '_loading'] = false
                    }

                    if (field === 'dmas') {
                        this.$data['all_cities_' + order] = res.data.cities
                        this.$data['all_cities_' + order + '_copy'] = res.data.cities
                        this.$data['cities_' + order + '_loading'] = false
                    }
                })
        },
        dataReloading(field, order) {
            if (field === 'segments') {
                this.$data['categories_' + order + '_loading'] = true
                this.$data['analysis_data_' + order + '_loading'] = true
                this.$data['countries_' + order + '_loading'] = true
                this.$data['states_' + order + '_loading'] = true
                this.$data['dmas_' + order + '_loading'] = true
                this.$data['cities_' + order + '_loading'] = true
            }
            if (field === 'categories') {
                this.$data['analysis_data_' + order + '_loading'] = true
                this.$data['countries_' + order + '_loading'] = true
                this.$data['states_' + order + '_loading'] = true
                this.$data['dmas_' + order + '_loading'] = true
                this.$data['cities_' + order + '_loading'] = true
            }
            if (field === 'analysis_data') {
                this.$data['countries_' + order + '_loading'] = true
                this.$data['states_' + order + '_loading'] = true
                this.$data['dmas_' + order + '_loading'] = true
                this.$data['cities_' + order + '_loading'] = true
            }
            if (field === 'countries') {
                this.$data['states_' + order + '_loading'] = true
                this.$data['dmas_' + order + '_loading'] = true
                this.$data['cities_' + order + '_loading'] = true
            }
            if (field === 'states') {
                this.$data['dmas_' + order + '_loading'] = true
                this.$data['cities_' + order + '_loading'] = true
            }
            if (field === 'dmas') {
                this.$data['cities_' + order + '_loading'] = true
            }
        },
        async createNewActivation() {
            await api.createNewActivation({
                _token: $('meta[name="_token"]').attr('content'),
                description: this.description,
                query: this.query,
                startDate: this.startDate,
                endDate: this.endDate,
                crossvisitation_process: this.crossVisitation,
                poi_location_level: this.poi_location_level,
                crossapps_process: this.crossApps,
                frequency_process: this.frequency,
                minfreq: this.minfreq,
                maxfreq: this.maxfreq,
                analysistype_0: this.analysis_type_0,
                signalproviders_0: this.signal_providers_0,
                categories_0: this.categories_0,
                analysisdata_0: this.analysis_data_0,
                countries_0: this.countries_0,
                states_0: this.states_0,
                cities_0: this.cities_0,
                dmas_0: this.dmas_0,
                cohorts_0: this.cohorts_0,
                zip_codes_0: this.zip_codes_0,
                analysistype_1: this.analysis_type_1,
                signalproviders_1: this.signal_providers_1,
                categories_1: this.categories_1,
                analysisdata_1: this.analysis_data_1,
                countries_1: this.countries_1,
                states_1: this.states_1,
                cities_1: this.cities_1,
                dmas_1: this.dmas_1,
                cohorts_1: this.cohorts_1,
                zip_codes_1: this.zip_codes_1,
                abnormality: this.abnormality,
                categories_cross: this.categories_cross,
                analysisdata_cross: this.analysis_data_cross,
            })
            .then(res => {
                this.$parent.showCreateDialog = false;
                if (typeof this.$parent.fetchData === 'function') {
                    this.$parent.fetchData()
                }
            })
            .catch(e => {
                this.$parent.alert = true
                this.$parent.notifications.push({id: Date.now(), type: 'error', message: e.response.data.message})
                this.$parent.showCreateDialog = false;
            })
        },
        submitData() {
            if (this.$refs.form.validate()) {
                this.createNewActivation()
            }
        },
        close() {
            this.$parent.showCreateDialog = false
        },
        toggle(data, order) {
            this.$nextTick(() => {
                if (this.selectedAll(data, order)) {
                    this.$data[data + '_' + order] = []
                } else {
                    this.$data[data + '_' + order] = this.$data['all_' + data + '_' + order].map(a => {
                        return a.value
                    })
                }
            })
        },
        search(data, order) {
            if (!this.$data['search_' + data + '_' + order]) {
                this.$data['all_' + data + '_' + order] = this.$data['all_' + data + '_' + order + '_copy'];
            }
            this.$data['all_' + data + '_' + order] = this.$data['all_' + data + '_' + order + '_copy'].filter((item) => {
                if (data === 'countries') {
                    return item.text.toLowerCase().indexOf(this.$data['search_' + data + '_' + order].toLowerCase()) > -1 || item.value.toLowerCase().indexOf(this.$data['search_' + data + '_' + order].toLowerCase()) > -1;
                } else {
                    return item.text.toLowerCase().indexOf(this.$data['search_' + data + '_' + order].toLowerCase()) > -1;
                }
            })
        },
        setRecency(data, type) {
            let today = new Date()
            let startDay = ''
            let startMonth = ''
            let startYear = ''
            let endDay = ''
            let endMonth = ''
            let endYear = ''

            if (type === 'days') {
                let first = today.getDate()
                let last = first - data

                let end = new Date(today.setDate(first))
                let start = new Date(today.setDate(last))

                startDay = ("0" + start.getDate()).slice(-2)
                startMonth = ("0" + (start.getMonth() + 1)).slice(-2)
                startYear = start.getFullYear()

                endDay = ("0" + end.getDate()).slice(-2)
                endMonth = ("0" + (end.getMonth() + 1)).slice(-2)
                endYear = end.getFullYear()
            }

            if (type === 'period') {
                if (data === 'last-month') {
                    let start = new Date(today.getFullYear(), today.getMonth() -1, 1)
                    let end = new Date(today.getFullYear(), today.getMonth(), 0)

                    startDay = ("0" + start.getDate()).slice(-2)
                    startMonth = ("0" + (start.getMonth() + 1)).slice(-2)
                    startYear = start.getFullYear()

                    endDay = ("0" + end.getDate()).slice(-2)
                    endMonth = ("0" + (end.getMonth() + 1)).slice(-2)
                    endYear = end.getFullYear()
                }

                if (data === 'this-month') {
                    let start = new Date(today.getFullYear(), today.getMonth(), 1)
                    let end = today

                    startDay = ("0" + start.getDate()).slice(-2)
                    startMonth = ("0" + (start.getMonth() + 1)).slice(-2)
                    startYear = start.getFullYear()

                    endDay = ("0" + end.getDate()).slice(-2)
                    endMonth = ("0" + (end.getMonth() + 1)).slice(-2)
                    endYear = end.getFullYear()
                }
            }

            this.startDate = startYear + '-' + startMonth + '-' + startDay
            this.endDate = endYear + '-' + endMonth + '-' + endDay
        },
        requiredCategories_0(v) {
            if (v.length > 0 || this.checkCategories_0) {
                return true
            } else {
                return 'Category field is required'
            }
        },
        requiredCategories_1(v) {
            if (v.length > 0 || this.checkCategories_1) {
                return true
            } else {
                return 'Category field is required'
            }
        },
        requiredValidCategories(v) {
            if (v.length > 0) {
                if (this.checkBrandsAvailable) {
                    return true
                } else {
                    return 'Categories selected doesn\'t contain brands'
                }
            } else {
                return true
            }
        },
        zipCodeValidation(v) {
            if (v.length > 0) {
                const tmp = v.split("\n")
                let fail = ''
                let status = true
                tmp.forEach(function (item, index) {
                    if (!/^[a-zA-Z0-9]*$/.test(item)) {
                        fail = index + 1
                        status = false
                    } else {
                        return true
                    }
                })

                return (status) ? true : 'Zipcode ' + fail + ' is invalid'

            } else {
                return true
            }
        },
        usePropsData() {
            this.analysis_type_0 = this.dataObject.type
            this.signal_providers_0 = this.dataObject.providers
            this.segments_0 = this.dataObject.segments
            this.categories_0 = this.dataObject.categories
            this.analysis_data_0 = this.dataObject.brands
            this.countries_0 = this.dataObject.countries
            this.states_0 = this.dataObject.states
            this.dmas_0 = this.dataObject.dmas
            this.cities_0 = this.dataObject.cities
            this.startDate = this.dataObject.start_date
            this.endDate = this.dataObject.end_date
        }
    },
    computed: {
        checkCategories_0() {
            if (this.analysis_data_0.length > 0) {
                return true
            } else {
                return false
            }
        },
        checkCategories_1() {
            if (this.analysis_data_1.length > 0) {
                return true
            } else {
                return false
            }
        },
        checkBrandsAvailable() {
            if (this.all_analysis_data_cross.length > 0) {
                return true
            } else {
                return false
            }
        },
        selectedAll() {
            return (data, order) => {
                return this.$data[data + '_' + order].length === this.$data['all_' + data + '_' + order].length
            }
        },
        selectedSome() {
            return (data, order) => {
                return this.$data[data + '_' + order].length > 0 && !this.selectedAll(data, order)
            }
        },
        icon() {
            return (data, order) => {
                if (this.selectedAll(data, order)) return 'mdi-close-box'
                if (this.selectedSome(data, order)) return 'mdi-minus-box'
                return 'mdi-checkbox-blank-outline'
            }
        },
    },
    watch: {
        analysis_data_0: function() {
            if (this.analysis_type_0 === 'POI' && !this.dataInitialLoading) {
                this.fetchChangedData('analysis_data', '0')
            }
        },
        analysis_data_1: function() {
            if (this.analysis_type_1 === 'POI' && !this.dataInitialLoading) {
                this.fetchChangedData('analysis_data', '1')
            }
        },
        analysis_type_0: function () {
            if (this.analysis_type_0 === 'POI') {
                this.analysis_data_label_0 = 'Brands'
            } else if (this.analysis_type_0 === 'Apps') {
                this.analysis_data_label_0 = 'Apps'
            } else {
                this.analysis_data_label_0 = 'Analysis Data'
            }
        },
        analysis_type_1: function () {
            if (this.analysis_type_1 === 'POI') {
                this.analysis_data_label_1 = 'Brands'
            } else if (this.analysis_type_1 === 'Apps') {
                this.analysis_data_label_1 = 'Apps'
            } else {
                this.analysis_data_label_1 = 'Analysis Data'
            }
        },
        segments_0: function () {
            if (this.analysis_type_0 === 'POI' && !this.dataInitialLoading) {
                this.fetchChangedData('segments', '0')
            }
        },
        segments_1: function () {
            if (this.analysis_type_1 === 'POI' && !this.dataInitialLoading) {
                this.fetchChangedData('segments', '1')
            }
        },
        categories_0: function () {
            if (this.categories_0 === 'POI' && !this.dataInitialLoading) {
                this.fetchChangedData('categories', '0')
            }
        },
        categories_1: function () {
            if (this.categories_1 === 'POI' && !this.dataInitialLoading) {
                this.fetchChangedData('categories', '1')
            }
        },
        categories_cross: function () {
            this.fetchAnalysisDataByCategory('cross')
        },
        countries_0: function () {
            if (this.countries_0 === 'POI' && !this.dataInitialLoading) {
                this.fetchChangedData('countries', '0')
            }
        },
        countries_1: function () {
            if (this.countries_1 === 'POI' && !this.dataInitialLoading) {
                this.fetchChangedData('countries', '1')
            }
        },
        states_0: function () {
            if (this.states_0 === 'POI' && !this.dataInitialLoading) {
                this.fetchChangedData('states', '0')
            }
        },
        states_1: function () {
            if (this.states_1 === 'POI' && !this.dataInitialLoading) {
                this.fetchChangedData('states', '1')
            }
        },
    },
    mounted() {
        this.fetchAnalysisTypes()
        // this.fetchSignalProviders()
        // this.fetchSegments()
        this.fetchCategories()
        // this.fetchCountries()
        // this.fetchDmas()
        this.fetchCohorts()
        this.fetchUserPermissions()
        this.fetchInitialData()
    },
}
</script>

<style>
.push-down-36 {
    margin-top: 36px;
}

.v-input--selection-controls {
    margin-top: 1px;
}

.v-date-picker-table {
    height: auto !important;
}

.fade-enter-active, .fade-leave-active {
    transition: opacity .5s
}
.fade-enter, .fade-leave-to /* .fade-leave-active in <2.1.8 */ {
    opacity: 0
}

.card {
    border: none;
}

.v-input--radio-group__input .checked label {
    background-color: #ff7516;
    border-color: #ff7516;
    color: #fff;
}

.v-input__slot .v-label {
    margin-bottom: 0;
}

.v-input--radio-group__input .v-radio .v-input--selection-controls__input {
    display: none;
}

.v-btn:not(.v-btn--round).v-size--default {
    height: 36px;
    min-width: 32px;
    padding: 0 12px;
}

.v-dialog__content--active {
    z-index: 99998 !important;
}

.recency-options > span {
    color: #ff7516;
    border-bottom: 1px solid white;
    transition: border-bottom .3s ease-in-out;
}

.recency-options > span:hover {
    border-bottom: 1px solid #ff7516;
    cursor: pointer;
}
</style>